export default __webpack_public_path__ + "static/Download on Google Play-d346256feeb60778c6f3579729347d60.png";